import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    modalWrapper: {
        padding: '15px',
        marginLeft: '1%',
        alignSelf: "center",
        height: "auto",
        boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
        borderRadius: "10px",
        backgroundColor: ({ theme }) => theme.palette.bgColor
    },
    text: {
        color: ({ theme }) => theme.palette.text.primary,
        marginBottom: '2%'
    },
    btn: {
        color: ({ theme }) => theme.palette.mode === 'light' ? "#9a0143" : "#fff",
        fontFamily: 'Rubik',
        '&:hover': {
            backgroundColor: ({ theme }) => theme.palette.mode === 'light' ? 'rgba(128, 128, 128, 0.2)' : "#9a0143",
        }
    },
    popup: {
        display: 'flex',
        justifyContent: 'center',
    },
    btnWrapper: {
        display: 'flex',
        justifyContent: 'center',
        gap: '10%'
    },
    multiline: {
        whiteSpace: 'pre-line'
    },
    fontBold: {
        fontWeight: '600'
    }
})